import { render, staticRenderFns } from "./DotagBadge.vue?vue&type=template&id=de0f20f2&scoped=true"
import script from "./DotagBadge.vue?vue&type=script&lang=js"
export * from "./DotagBadge.vue?vue&type=script&lang=js"
import style0 from "./DotagBadge.vue?vue&type=style&index=0&id=de0f20f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0f20f2",
  null
  
)

export default component.exports